/* eslint-disable @typescript-eslint/no-explicit-any */
export type Create = <T>(defaults: T) => (overrides?: Partial<T>) => T;
export const create: Create = (defaults) => (overrides) => ({
  ...(defaults as any),
  ...(overrides as any),
});
